import { faEllipsis } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  FlexBox,
  JoonUIColor,
  QuestInstance,
  QuestStatus,
  SPACING,
} from "@joonapp/web-shared"

import { useQuestActionsModalStore } from "./QuestActionsModal"
import StatusBadge from "../../../components/badges/statusBadge/StatusBadge"
import UserBadge from "../../../components/badges/userBadge/UserBadge"
import Card from "../../../components/card/Card"
import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../../../util/analytics"
import { useReviewQuestModalStore } from "../useReviewQuestModalStore"

export const ChildQuestStatusCard = ({
  questInstance,
}: {
  questInstance: QuestInstance
}) => {
  const { onOpen: onOpenQuestActionsModal } = useQuestActionsModalStore()
  const { onOpen: openReviewQuestModal, setQuest: setQuestToReview } =
    useReviewQuestModalStore()

  const onClick = () => {
    if (questInstance.status === QuestStatus.COMPLETED) {
      setQuestToReview(questInstance)
      openReviewQuestModal()
    } else {
      trackAnalyticEvent(ANALYTIC_EVENTS.OPEN_QUEST_STATUS_MODAL)
      onOpenQuestActionsModal(questInstance)
    }
  }

  return (
    <Card
      title={<UserBadge userId={questInstance.user_id} />}
      onClick={onClick}
      coinAmount={questInstance.redeemable_reward || undefined}
      buttonComponent={
        <FlexBox
          direction="row"
          align="center"
          gap={SPACING.space2}
          wrap={false}
          style={{ width: "fit-content" }}
        >
          <StatusBadge status={questInstance.status} />
          <FontAwesomeIcon icon={faEllipsis} color={JoonUIColor.icon.neutral} />
        </FlexBox>
      }
      style={{
        height: SPACING.space12,
        padding: SPACING.space3,
      }}
    />
  )
}
